import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "../config/api";

import {
  BarChart, AreaChart, Area, ScatterChart, ZAxis, Scatter,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  Legend, CartesianGrid
} from "recharts";
import "./Css/Dashboard.css";

const BAR_COLORS = {
  उत्तीर्ण: "#7086FD",
  सरासरी: "#6FD195",
  अनुत्तीर्ण: "#FFAE4C",
};

const datapie = [
  { value: 48, color: "#8b80ff", x: 90, y: 30 }, // big purple
  { value: 30, color: "#63bfff", x: 190, y: 70 }, // blue
  { value: 24, color: "#f7b2ff", x: 180, y: 0 },  // pink
  { value: 15, color: "#c9ffe1", x: 240, y: 30 },  // mint
  { value: 10, color: "#ffcc00", x: 50, y: 20 },  // yellow
  { value: 8, color: "#21c55d", x: 80, y: 130 }, // green
];
const items = [
  { color: "#8A82F7", label: "सराव प्रश्नपत्रिका संच क्रमांक तीन" },
  { color: "#5DA2F7", label: "भाषा परीक्षण 500 उत्तारे" },
  { color: "#F49FE3", label: "Alphabet writing book" },
  { color: "#C7F7D4", label: "सुलभ वाचन - लेखन" },
  { color: "#FFD43D", label: "माझी सुलेखन पुस्तिका" },
  { color: "#38C172", label: "सराव प्रश्नपत्रिका संच क्रमांक एक" },
];


const datapayment = [
  {
    school: "ज्ञानदीप इंग्लिश स्कूल",
    मिळकत: 14000,
    पेंडिंग: 8000
  },
  {
    school: "सह्याद्री इंग्लिश स्कूल",
    मिळकत: 14000,
    पेंडिंग: 9000
  },
  {
    school: "ज्ञानदीप विद्यालय, फटण",
    मिळकत: 25000,
    पेंडिंग: 10000
  },
  {
    school: "अर्णना विघर्मंदिर, पाटण",
    मिळकत: 18000,
    पेंडिंग: 3000
  },
  {
    school: "शिवांगा विद्या निकेतन, सातारा",
    मिळकत: 16000,
    पेंडिंग: 9000
  }
];

const COLORS = [
  "#8979FF",
  "#5AD8CC",
  "#EA4335",
  "#FFAE4C",
  "#34A853",
];
const activities = [
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 19 17" fill="none">
      <path d="M0 17V0H9V4H18.5385V17H0ZM1 16H8V13H1V16ZM1 12H8V9H1V12ZM1 8H8V5H1V8ZM1 4H8V1H1V4ZM9 16H17.5385V5H9V16ZM11.3847 9V8H14.7693V9H11.3847ZM11.3847 13V12H14.7693V13H11.3847Z" fill="white" />
    </svg>,
    color: "blue",
    title: "नवीन संस्था नोंदणी",
    desc: "ज्ञानदीप विद्यालय यांनी नोंदणी केली",
    time: "आज, सकाळी १०:३०"
  },
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 17 18" fill="none">
      <path d="M12.3077 17.6923C11.1936 17.6923 10.2483 17.3042 9.472 16.528C8.69583 15.7517 8.30775 14.8064 8.30775 13.6923C8.30775 12.5782 8.69583 11.6331 9.472 10.8567C10.2483 10.0804 11.1936 9.69225 12.3077 9.69225C13.4218 9.69225 14.3669 10.0804 15.1432 10.8567C15.9196 11.6331 16.3078 12.5782 16.3078 13.6923C16.3078 14.8064 15.9196 15.7517 15.1432 16.528C14.3669 17.3042 13.4218 17.6923 12.3077 17.6923ZM12.3077 16.5385C12.4586 16.5385 12.5853 16.4871 12.688 16.3843C12.7908 16.2814 12.8422 16.1546 12.8422 16.0038C12.8422 15.8531 12.7908 15.7263 12.688 15.6235C12.5853 15.5207 12.4586 15.4693 12.3077 15.4693C12.1569 15.4693 12.0301 15.5207 11.9273 15.6235C11.8244 15.7263 11.773 15.8531 11.773 16.0038C11.773 16.1546 11.8244 16.2814 11.9273 16.3843C12.0301 16.4871 12.1569 16.5385 12.3077 16.5385ZM11.9345 14.7538H12.6807V14.5807C12.6807 14.3846 12.7308 14.2253 12.8307 14.103C12.9307 13.9805 13.0474 13.8526 13.1807 13.7193C13.4141 13.5193 13.5974 13.3147 13.7308 13.1058C13.8641 12.8967 13.9307 12.6361 13.9307 12.3238C13.9307 11.8708 13.7804 11.4984 13.4798 11.2067C13.1793 10.9151 12.7917 10.7692 12.317 10.7692C11.9532 10.7692 11.6171 10.8818 11.3087 11.1067C11.0004 11.3317 10.7796 11.6231 10.6462 11.9808L11.3307 12.2537C11.4064 12.0538 11.5298 11.8787 11.701 11.7288C11.8722 11.5787 12.0744 11.5037 12.3077 11.5037C12.5817 11.5037 12.7964 11.5722 12.9518 11.709C13.1069 11.8457 13.1845 12.0507 13.1845 12.3243C13.1845 12.5247 13.1282 12.6907 13.0155 12.822C12.9027 12.9535 12.7796 13.0859 12.6462 13.2193C12.5462 13.3193 12.4485 13.4257 12.353 13.5385C12.2573 13.6513 12.1678 13.7634 12.0845 13.8748C12.0345 13.9583 11.997 14.0532 11.972 14.1595C11.947 14.266 11.9345 14.3719 11.9345 14.4772V14.7538ZM9 5H13L9 1V5ZM1.6155 18C1.17117 18 0.790833 17.8418 0.4745 17.5255C0.158167 17.2092 0 16.8288 0 16.3845V1.6155C0 1.17117 0.158167 0.790833 0.4745 0.4745C0.790833 0.158166 1.17117 0 1.6155 0H9.5L14 4.5V7.53075C13.718 7.44358 13.4392 7.38458 13.1635 7.35375C12.8878 7.32308 12.6026 7.30775 12.3077 7.30775C11.3449 7.30775 10.4491 7.50292 9.62025 7.89325C8.79142 8.28358 8.08592 8.81917 7.50375 9.5H3.5V10.5H6.7905C6.53783 10.9448 6.33583 11.4205 6.1845 11.927C6.03333 12.4333 5.952 12.9577 5.9405 13.5H3.5V14.5H5.9745C6.0685 15.1475 6.252 15.769 6.525 16.3645C6.798 16.96 7.15825 17.5052 7.60575 18H1.6155Z" fill="white" />
    </svg>,
    color: "green",
    title: "प्रश्न मंजूर",
    desc: "विज्ञान इयत्ता ७ साठी २५ प्रश्न मंजूर",
    time: "आज, सकाळी ९:१५"
  },
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 11 16" fill="none">
      <path d="M7.052 16L1 9.69225V8.3845H4C5.0115 8.3845 5.93108 8.065 6.75875 7.426C7.58625 6.78683 8.009 5.87558 8.027 4.69225H0V3.69225H7.91925C7.71275 2.90375 7.25025 2.25792 6.53175 1.75475C5.81308 1.25158 4.96917 1 4 1H0V0H11V1H7.05775C7.53458 1.28333 7.948 1.66542 8.298 2.14625C8.648 2.62692 8.86658 3.14225 8.95375 3.69225H11V4.69225H9.03275C9.02758 6.10892 8.52117 7.24517 7.5135 8.101C6.50583 8.95667 5.33467 9.3845 4 9.3845H2.102L8.44225 16H7.052Z" fill="white" />
    </svg>,
    color: "teal",
    title: "पेमेंट प्राप्त",
    desc: "विद्या मंदिर कडून ₹१५,००० प्राप्त",
    time: "काल, संध्याकाळी ४:४५"
  },
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 18 19" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4643 6.55464V5.34704C12.5201 5.11356 12.5977 5.09036 12.714 5.06871C13.0273 5.02078 12.9916 6.47578 12.4643 6.55464ZM12.8412 14.4574C12.8396 14.445 12.8381 14.4326 12.8381 14.4172C12.8381 14.4048 12.8396 14.3909 12.8412 14.3785V13.525C12.1339 13.4678 11.4018 13.5327 10.7643 13.7384C10.1672 13.9301 9.65377 14.2425 9.32029 14.6924V18.2472C9.8399 17.9549 10.3704 17.8251 10.9163 17.6596C11.5383 17.4725 12.1789 17.3828 12.8412 17.4292V14.4574ZM8.70763 18.3106V14.6862C8.38656 14.2084 7.86851 13.8884 7.28221 13.6982C6.61835 13.4833 5.8723 13.4353 5.22085 13.5126L5.18673 17.4462C5.89556 17.4246 6.59044 17.5004 7.24188 17.6813C7.76303 17.8235 8.25627 18.0338 8.70763 18.3106ZM13.5454 18.4111C12.9063 18.2858 12.272 18.207 11.6422 18.2039C10.8233 18.1992 10.0043 18.6507 9.18225 18.9569C9.13107 18.9847 9.07057 19.0002 9.00853 19.0002C8.94649 19.0002 8.886 18.9863 8.83326 18.9569C6.85412 18.2163 6.59974 17.989 4.45463 18.4142C4.45463 17.1865 4.49806 16.3855 4.53839 15.5815H0.932185C0.347437 15.5397 0.0496338 15.2367 0 14.7156C0.201637 13.8203 0.24972 13.2189 0.804998 12.489C1.02835 12.1953 1.30444 11.9772 1.61155 11.8087C2.58251 11.2691 5.68307 11.1114 6.56407 10.3197L7.55829 13.2343C7.76148 13.3024 7.95692 13.3843 8.14149 13.4817L8.5913 11.9278L8.25937 11.5659C8.11047 11.3479 8.07635 11.1562 8.1601 10.9938C8.34003 10.6382 8.71228 10.7047 9.06127 10.7047C9.42577 10.7047 9.87557 10.6367 9.99035 11.0897C10.0291 11.2412 9.97949 11.4005 9.87402 11.5659L9.5421 11.9278L9.99035 13.4786C10.1625 13.3967 10.344 13.324 10.5332 13.2637L11.4421 10.3212C12.3231 11.1114 15.4237 11.2706 16.3931 11.8103C16.6987 11.9819 16.9779 12.1984 17.2012 12.4906C17.7565 13.2204 17.803 13.8219 18.0062 14.7172C17.9566 15.2398 17.6588 15.5413 17.074 15.5846H13.4926C13.5175 16.3917 13.5454 17.1726 13.5454 18.4111ZM6.95648 5.24808C6.88979 5.27436 6.81844 5.23261 6.79362 5.15994C6.77036 5.08418 6.80603 5.00223 6.87273 4.97749C7.38458 4.77957 7.74907 4.79194 8.26247 4.97749C8.32917 5.00223 8.36639 5.08263 8.34623 5.1584C8.32607 5.23416 8.25317 5.27591 8.18802 5.25272C8.10272 5.22334 8.01741 5.19551 7.9321 5.17695C7.94141 5.20633 7.94606 5.2388 7.94606 5.27282C7.94606 5.46919 7.78785 5.62999 7.58776 5.62999C7.39078 5.62999 7.22947 5.46919 7.22947 5.27282C7.22947 5.22334 7.23878 5.1785 7.25584 5.13675C7.10539 5.15221 7.10849 5.18932 6.95648 5.24808ZM9.88798 5.24808C9.82129 5.27436 9.74994 5.23261 9.72512 5.15994C9.70185 5.08418 9.73753 5.00223 9.80422 4.97749C10.3145 4.77957 10.6806 4.79194 11.194 4.97749C11.2607 5.00223 11.2979 5.08263 11.2777 5.1584C11.2576 5.23416 11.1847 5.27591 11.1195 5.25272C11.0342 5.22334 10.9489 5.19551 10.8636 5.17695C10.8729 5.20633 10.8776 5.2388 10.8776 5.27282C10.8776 5.46919 10.7178 5.62999 10.5193 5.62999C10.3223 5.62999 10.1625 5.46919 10.1625 5.27282C10.1625 5.22334 10.1718 5.1785 10.1889 5.13675C10.0353 5.15221 10.04 5.18932 9.88798 5.24808ZM8.60215 6.84842C8.54166 6.79739 8.53236 6.70617 8.58354 6.64586C8.63473 6.58556 8.72624 6.57628 8.78673 6.62731C8.85963 6.68916 8.92943 6.72008 8.99457 6.72008C9.06127 6.72163 9.13417 6.6907 9.21172 6.62576C9.27221 6.57474 9.36372 6.58556 9.41491 6.64586C9.46609 6.70617 9.45679 6.79739 9.39474 6.84842C9.26291 6.95665 9.12641 7.00923 8.99147 7.00613C8.85498 7.00459 8.72624 6.95047 8.60215 6.84842ZM10.0958 7.93851C9.97794 7.97871 9.85541 8.01272 9.72977 8.04056C9.59948 8.07612 9.4816 8.09777 9.37613 8.10086C9.25515 8.10241 9.15123 8.08076 9.06902 8.02664C9.04421 8.00963 9.02094 7.99262 9.00078 7.97252C8.98061 7.99108 8.9589 8.00963 8.93253 8.02664C8.85032 8.0823 8.7464 8.10395 8.62542 8.10086C8.51995 8.09777 8.40052 8.07767 8.27178 8.04056C8.14614 8.01272 8.02361 7.97871 7.90418 7.93851C7.7863 7.8983 7.66997 7.85192 7.55829 7.79935C7.50401 7.77461 7.48229 7.7143 7.51021 7.66328C7.52727 7.6339 7.55674 7.6138 7.58932 7.60916C7.64981 7.59988 7.69789 7.5937 7.74287 7.58751L7.74597 7.58597C7.89177 7.56587 8.0019 7.5504 8.13839 7.49629C8.17717 7.48082 8.21439 7.46382 8.25162 7.44681C8.46876 7.3463 8.70608 7.23807 8.94339 7.42516C8.96355 7.44217 8.98216 7.45763 8.99923 7.47619C9.01629 7.45763 9.0349 7.44217 9.05506 7.42516C9.29082 7.23652 9.52969 7.3463 9.74683 7.44681C9.78406 7.46382 9.82129 7.48082 9.86006 7.49629C9.99655 7.5504 10.1082 7.56587 10.2525 7.58597L10.2571 7.58751C10.3021 7.5937 10.3502 7.59988 10.4107 7.60916C10.4433 7.61535 10.4743 7.6339 10.4898 7.66328C10.5177 7.71276 10.496 7.77461 10.4417 7.79935C10.33 7.85192 10.2137 7.8983 10.0958 7.93851ZM4.81913 2.80968V2.27623C4.93081 1.35159 5.362 0.980498 6.07238 1.08719C6.74554 0.385202 7.69789 -0.00753889 9.01008 0.00173846C10.4696 -0.0276398 11.7151 0.312529 12.6178 1.23563C13.0925 1.70722 13.2957 2.19892 13.1731 3.23799C13.1979 4.25695 13.3112 4.34044 12.9792 4.5198C12.9777 4.54764 12.9761 4.57547 12.9746 4.60485L12.7466 4.74865C12.9312 4.73473 13.0599 4.84915 13.1374 5.04397C13.1747 5.14139 13.1995 5.26045 13.2103 5.39033C13.2196 5.51093 13.2181 5.64546 13.201 5.78152C13.1467 6.27632 12.9187 6.79275 12.4969 6.85306C12.4782 6.85615 12.4596 6.85615 12.4426 6.8546V6.918C12.4426 6.92109 12.4426 6.92418 12.4426 6.92728C12.4705 7.61844 12.1044 8.38537 11.5135 8.99922C10.4386 10.1171 8.6735 10.6738 7.13951 9.40742C6.87273 9.18631 6.56252 8.96984 6.319 8.62812C6.3221 8.62503 6.32521 8.62194 6.32676 8.62039L6.32055 8.61575C5.92503 8.2493 5.73891 8.07612 5.5807 7.32311C5.5776 7.30919 5.57605 7.29218 5.57605 7.27827V6.8546C5.55433 6.85924 5.53106 6.85924 5.5078 6.8546C5.08436 6.79275 4.85791 6.27632 4.80362 5.78307C4.78966 5.647 4.78656 5.51248 4.79431 5.39188C4.80517 5.26199 4.82999 5.14293 4.86721 5.04552C4.95097 4.83369 5.09677 4.71618 5.30616 4.75638C5.40698 4.77493 5.50004 4.82596 5.57605 4.91409V4.74246L5.40543 4.6466C5.38527 4.50744 5.38216 4.36673 5.39147 4.22293C5.08281 3.70804 4.8424 3.20706 4.81913 2.80968ZM11.9866 4.53063C11.7849 3.96626 11.5181 3.90286 11.0311 3.60599C10.6232 3.42972 10.2649 3.27973 9.92521 3.17304C9.1016 2.99059 8.19733 3.04316 7.44817 3.2921C7.24963 3.36941 7.03714 3.46373 6.81069 3.57661C6.33296 3.85493 6.11116 3.88276 6.01034 4.35745V7.27518C6.18096 8.08849 6.16855 7.93696 6.69125 8.44721L7.59862 9.33165C7.76303 9.46618 7.94761 9.54503 8.14304 9.59142C8.81465 9.74914 10.2246 9.68574 10.7535 9.13064C11.5414 8.36681 12.0377 8.13642 11.9819 6.91491V4.53063H11.9866ZM8.25627 8.62503C8.19113 8.58947 8.16631 8.50752 8.20043 8.44412C8.23611 8.37918 8.31831 8.35289 8.38191 8.38846C8.58975 8.49824 8.79294 8.5539 8.99457 8.55545C9.19466 8.55545 9.3963 8.50133 9.59793 8.39C9.66308 8.35444 9.74528 8.37763 9.78096 8.44258C9.81663 8.50752 9.79337 8.58792 9.72822 8.62503C9.48626 8.75801 9.24274 8.82449 8.99612 8.8214C8.74795 8.81985 8.50134 8.75491 8.25627 8.62503ZM5.53727 6.55464V5.34704C5.48143 5.11356 5.41474 5.10273 5.29996 5.08108C4.98819 5.03315 4.9944 6.43867 5.53727 6.55464Z" fill="white" />
    </svg>,
    color: "sky",
    title: "नवीन शिक्षक नोंदणी",
    desc: "सरस्वती विद्यालयात ३ नवीन शिक्षक जोडले",
    time: "काल, दुपारी २:३०"
  }
];

export default function Dashboard() {
  const navigate = useNavigate();
  const values = datapie.map(item => Number(item.value));

  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);

  const minSize = 60;
  const maxSize = 120;

  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [barData, setBarData] = useState([]);
  const [softwareDistribution, setSoftwareDistribution] = useState([]);

  const [summary, setSummary] = useState({
    institutes: 0,
    teachers: 0,
    students: 0,
    papers: 0,
    questions: 0
  });

  const topCards = [
    { title: <>...एकूण संस्था</>, value: summary.institutes, color: "mint" },
    { title: <>...एकूण शिक्षक</>, value: summary.teachers, color: "purple" },
    { title: <>...एकूण विद्यार्थी</>, value: summary.students, color: "yellow" },
    { title: <>...एकूण परीक्षा</>, value: summary.papers, color: "green" },
    { title: <>...एकूण प्रश्नसंचातील प्रश्न</>, value: summary.questions, color: "pink" }
  ];

  const [data, setData] = useState([]);

  const apiUrl = `${API_BASE}`;


  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/Dashboard/dashboard/summary`);

        setSummary({
          institutes: res.data.institutes,
          teachers: res.data.teachers,
          students: res.data.students,
          papers: res.data.papers,
          questions: res.data.questions
        });
      } catch (err) {
        console.error("Dashboard summary error:", err);
      }
    };

    fetchSummary();
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/api/Dashboard/student-registrations`)
      .then(res => res.json())
      .then(res => {
        const marathiMonths = [
          "जाने", "फेब्रु", "मार्च", "एप्रि", "मे", "जून",
          "जुलै", "ऑग", "सप्टे", "ऑक्टो", "नोव्हे", "डिसें"
        ];

        const formatted = res.map((item, index) => ({
          month: marathiMonths[index],
          students: item.students
        }));

        setData(formatted);
      });
  }, []);

  const handleCardClick = (index) => {
    if (index === 0) {
      navigate("/dashboard/institudemng");
    }
    // else if (index === 1) {
    //   navigate("/dashboard/institudeview", {
    //     state: { activeTab: "शिक्षक" }
    //   });
    // }
    // else if (index === 2) {
    //   navigate("/dashboard/institudeview", {
    //     state: { activeTab: "विद्यार्थी" }
    //   });
    // }
    else if (index === 3) {
      navigate("/dashboard/exammanagment");
    }
    else if (index === 4) {
      navigate("/dashboard/quemanagment");
    }
  };


  useEffect(() => {
    loadAnalysis();   // 👈 initial overall data
    loadStandards();  // existing standards load
  }, []);

  const loadStandards = async () => {
    const res = await axios.get(`${apiUrl}/api/dashboard/standards`);
    setStandards(res.data);
  };

  const loadAnalysis = async (standardId = "", subjectId = "") => {
    const res = await axios.get(
      `${apiUrl}/api/dashboard/analysis?standardId=${standardId}&subjectId=${subjectId}`
    );

    const formatted = res.data.map(x => ({
      name: x.name,
      उत्तीर्ण: x.passed,
      सरासरी: x.average,
      अनुत्तीर्ण: x.failed
    }));

    setBarData(formatted);
  };

  const handleStandardChange = async (e) => {
    const id = e.target.value;
    setSelectedStandard(id);

    // load subjects
    const res = await axios.get(`${apiUrl}/api/dashboard/subjects/${id}`);
    setSubjects(res.data);

    // reload chart with filter
    loadAnalysis(id, selectedSubject);
  };

  const handleSubjectChange = async (e) => {
    const id = e.target.value;
    setSelectedSubject(id);

    loadAnalysis(selectedStandard, id);
  };


  useEffect(() => {
    const loadSoftwareDistribution = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/Dashboard/dashboard/software-distribution`);
        setSoftwareDistribution(res.data);
      } catch (err) {
        console.error("Software distribution error:", err);
      }
    };

    loadSoftwareDistribution();
  }, []);



  return (
    <div className="dashboard">
      <div className="page-header">
        <h3>
          <span>नमस्कार सुपर ऍडमिन ... </span>
        </h3>

      </div>

      <div className="top-cards">
        {topCards.map((item, i) => (
          <div
            key={i}
            className={`cardy ${item.color}`}
            onClick={() => handleCardClick(i)}
            style={{ cursor: "pointer" }}          >

            <p className="card-title">{item.title}</p>
            <div className="card-content">
              {/* LEFT SIDE */}
              <div className="card-left">

                <p className="fix-value">Current Value</p>
                <h2 className="card-value">{item.value}</h2>
              </div>

              {/* RIGHT SIDE */}
              <div className="card-right">
                <div className="sparkline" />
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="25" viewBox="0 0 79 25" fill="none">
                  <path d="M76.9956 5.70937H78.5V24.1094L0.499999 24.1094V7.94958L2.75657 13.5496L3.6531 15.7896H4.70413L6.8062 13.5496L8.27764 15.7896L12.692 15.7898L15.0042 13.5496L16.2655 10.1891L18.1012 11.8696L19.756 13.5496L20.2728 16.1094L21.3239 15.7896H22.6144L25.0214 7.94958L25.7736 10.1896L26.9771 7.94958L27.8797 11.8696L30.2867 5.14959L31.6406 7.94958H34.1981L36.906 2.34959L38.5608 5.14959L40.7401 3.46937L43.3955 7.94936L45.1028 0.109374L46.3384 7.94936L54.5804 11.3094L55.6334 9.06936H56.6865L59.0935 5.70937H61.5005L62.4031 9.06936L66.0137 2.34937L67.518 11.3094L68.2702 7.94936H69.925L71.4294 0.109374L72.9338 6.82936L73.686 3.46937H75.6417L76.9956 5.70937Z" fill="url(#paint0_linear_805_17763)" fill-opacity="0.16" />
                  <path d="M78.5 5.70937H76.9956L75.6417 3.46937H73.686L72.9338 6.82936L71.4294 0.109374L69.925 7.94936H68.2702L67.518 11.3094L66.0137 2.34937L62.4031 9.06936L61.5005 5.70937H59.0935L56.6865 9.06936H55.6334L54.5804 11.3094L46.3384 7.94936L45.1028 0.109374L43.3955 7.94936L40.7401 3.46937L38.5608 5.14959L36.906 2.34959L34.1981 7.94958H31.6406L30.2867 5.14959L27.8797 11.8696L26.9771 7.94958L25.7736 10.1896L25.0214 7.94958L22.6144 15.7896H21.3239L20.2728 16.1094L19.756 13.5496L18.1012 11.8696L16.2655 10.1891L15.0042 13.5496L12.692 15.7898L8.27764 15.7896L6.80619 13.5496L4.70413 15.7896H3.6531L2.75658 13.5496L0.500001 7.94958" stroke="#6C8C3C" stroke-linecap="round" />
                  <defs>
                    <linearGradient id="paint0_linear_805_17763" x1="39.5" y1="24.1094" x2="39.5" y2="0.109374" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#77B900" stop-opacity="0" />
                      <stop offset="0.809892" stop-color="#77B900" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>

          </div>
        ))}
      </div>

      <div className="three-card">
        <div className="cardd">
          <h4>परीक्षा निकाल विश्लेषण</h4>
          <div className="filters">
            <select className="filter-select" onChange={handleStandardChange}>
              <option value="">इयत्ता निवडा</option>
              {standards.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>

            <select className="filter-select" onChange={handleSubjectChange}>
              <option value="">विषय निवडा</option>
              {subjects.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>

          <div className="bar-layout">
            {/* LEFT SIDE – CHART */}
            <div className="bar-chart">
              <ResponsiveContainer width="100%" height={330}>
                <BarChart
                  data={barData}
                  layout="vertical"
                  margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // legend outside
                >
                  {/* X Axis */}
                  <XAxis
                    type="number"
                    orientation="top"
                    domain={[0, 250]}
                    ticks={[0, 50, 100, 150, 200]}
                    tickFormatter={(v) => `${v}%`}
                    axisLine={false}
                    tickLine={false}
                  />

                  {/* Y Axis */}
                  <YAxis
                    type="category"
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    width={180}
                  />

                  {/* Grid */}
                  <CartesianGrid strokeDasharray="3 3" horizontal={false} />

                  {/* Tooltip */}
                  <Tooltip formatter={(v) => `${v}%`} />

                  {/* Stacked Bars */}
                  <Bar
                    dataKey="उत्तीर्ण"
                    stackId="a"
                    fill={BAR_COLORS["उत्तीर्ण"]}
                    barSize={30}
                    radius={[0, 0, 0, 0]}
                  />
                  <Bar
                    dataKey="सरासरी"
                    stackId="a"
                    fill={BAR_COLORS["सरासरी"]}
                    barSize={20}
                  />
                  <Bar
                    dataKey="अनुत्तीर्ण"
                    stackId="a"
                    fill={BAR_COLORS["अनुत्तीर्ण"]}
                    barSize={20}
                    radius={[0, 0, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>

          </div>

        </div>

        {/* Card 2 */}
        <div className="cardd">
          <h4>विद्यार्थी नोंदणी वाढ</h4>
          <ResponsiveContainer width="100%" height="90%">
            <AreaChart data={data} margin={{ top: 5, right: 30, left: 5, bottom: 5 }}>
              <defs>
                <linearGradient id="colorStudents" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8884d8" stopOpacity={0.4} />
                  <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="month" />
              <YAxis
                ticks={[0, 150, 300, 450, 600, 750]}
                domain={[0, 750]}
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
                width={40}
              />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip cursor={false} content={() => null} />
              <Area
                type="monotone"
                dataKey="students"
                name="2025"
                stroke="#7B6EF6"
                strokeWidth={2}
                fill="url(#colorStudents)"
                dot={{
                  r: 6,
                  fill: "#8979FF",
                  stroke: "#fff",
                  strokeWidth: 2
                }}
                activeDot={(props) => {
                  const { cx, cy, value, payload } = props;
                  return (
                    <g>
                      {/* Active dot */}
                      <circle
                        cx={cx}
                        cy={cy}
                        r={7}
                        fill="#8979FF"
                        stroke="#fff"
                        strokeWidth={2}
                      />

                      {/* Text background */}
                      <rect
                        x={cx - 45}
                        y={cy - 40}
                        width="90"
                        height="32"
                        rx="6"
                        fill="#ffffff"
                        stroke="#e0e0e0"
                      />

                      {/* Month */}
                      <text
                        x={cx}
                        y={cy - 26}
                        textAnchor="middle"
                        fontSize="11"
                        fill="#666"
                      >
                        {payload.month}
                      </text>

                      {/* विद्यार्थी नोंदणी value */}
                      <text
                        x={cx}
                        y={cy - 14}
                        textAnchor="middle"
                        fontSize="12"
                        fontWeight="600"
                        fill="#333"
                      >
                        विद्यार्थी {value} नोंदणी
                      </text>
                    </g>
                  );
                }}
              />
              <Legend
                verticalAlign="bottom"
                align="center"
                iconType="circle"
                wrapperStyle={{
                  paddingTop: "10px",
                  fontSize: "13px",
                  color: "#7B6EF6"
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="cardd">
          <h4>सर्वाधिक लोकप्रिय पुस्तके</h4>

          <div className="bubble-area">
            {datapie.map((item, index) => {
              const value = Number(item.value);   // ✅ define value

              const size =                       // ✅ define size
                minSize +
                ((value - minVal) / (maxVal - minVal || 1)) *
                (maxSize - minSize);

              return (
                <div
                  key={index}
                  className="bubble"
                  style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    backgroundColor: item.color,
                    left: `${item.x}px`,
                    top: `${item.y}px`,
                  }}
                >
                  <span>{value}%</span>
                </div>
              );
            })}
          </div>

          <div className="legend-container">
            {items.map((item, index) => (
              <div key={index} className="legend-items">
                <span
                  className="legend-color"
                  style={{ backgroundColor: item.color }}
                ></span>
                <span className="legend-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="cardd">
          <h4>पेमेंट स्थिती </h4>
          <ResponsiveContainer width="100%" height="90%">
            <BarChart
              layout="vertical"
              data={datapayment}
              margin={{ top: 0, right: 10, left: 0, bottom: 10 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                type="number"
                orientation="top"
                domain={[0, 25000]}
                ticks={[0, 5000, 10000, 15000, 20000, 25000]}
                tickFormatter={(value) => `${value / 1000}k`}
              />

              <YAxis
                type="category"
                dataKey="school"
                width={120}
                tick={{ fontSize: 12, fill: '#000' }}
              />
              <Tooltip />
              <Legend />
              <Bar dataKey="मिळकत" fill="#7086FD" />
              <Bar dataKey="पेंडिंग" fill="#6FD195" />
            </BarChart>
          </ResponsiveContainer>
        </div>


        <div className="cardd">
          <h4>संस्था नुसार परीक्षा वितरण</h4>

          <div className="pie-layout">
            {/* LEFT SIDE – GRAPH */}
            <div className="pie-chart">
              <ResponsiveContainer width="100%" height={260}>
                <PieChart>
                  <Pie
                    data={softwareDistribution}
                    dataKey="value"
                    nameKey="name"
                    cx="45%"
                    cy="50%"
                    innerRadius={65}     // donut thickness
                    outerRadius={100}
                    padAngle={14}         // gap between pieces
                    cornerRadius={25}
                    minAngle={8}
                    startAngle={90}
                    endAngle={-270}
                  // rounded ends (VERY IMPORTANT)
                  >
                    {softwareDistribution.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>

            </div>

            {/* RIGHT SIDE – DATA / LEGEND */}
            <div className="pie-legend">
              {softwareDistribution.map((item, index) => (
                <div key={index} className="legend-item">
                  <span
                    className="legend-color"
                    style={{ backgroundColor: COLORS[index % COLORS.length] }}
                  ></span>
                  <span className="legend-text">
                    {item.name} – {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="cardd">
          <h4>गेल्या ७ दिवसांतील कृती</h4>
          <div className="timeline">
            {activities.map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className={`icon-circle ${item.color}`}>
                  {item.icon}
                </div>

                <div className="timeline-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                  <span>{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
